import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cx from 'classnames';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import Grid from '../Grid';
import Input from '../Input';
import Form from '../Form';
import Popup from './Popup';
import SaveChangesButton from '../SaveChangeButtonPopup';
import s from './Popup.css';
import Messages from './Messages';
import { setDeviceCommandValue } from '../../actions/device';

class SendCommandPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commandToSend: '',
      valueToSend: '',
    };
  }

  onClick = () => {
    this.props.setDeviceCommandValue(
      this.props.serial,
      this.state.commandToSend,
      this.state.valueToSend
    );
    this.props.onClose();
  };

  onFieldChange = (field, e) => {
    this.setState({
      [field]: e,
    });
  };

  render() {
    const { intl, devicetype, serial } = this.props;
    const messages = Messages();

    return (
      <Popup
        className={s.Popup__editdevice}
        onClose={this.props.onClose}
        devicetype={devicetype}
        overrideOnClose
      >
        {serial}
        <Form onSubmit={this.onSubmit}>
          <Grid.Cell>
            <Input
              type="text"
              name="command"
              title={intl.formatMessage(messages.send_command_command_popup,)}
              onChange={this.onFieldChange.bind(this, 'commandToSend')}
              titleVisibility
            />
          </Grid.Cell>


          <Grid.Cell>
            <Input 
              type="text"
              name="value"
              title={intl.formatMessage(messages.send_command_value_popup,)}
              onChange={this.onFieldChange.bind(this, 'valueToSend')}
              titleVisibility
            />
          </Grid.Cell>
          <SaveChangesButton devicetype={devicetype} onClick={this.onClick} />
        </Form>
      </Popup>
    );
  }
}

SendCommandPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  setDeviceCommandValue: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  serial: PropTypes.string.isRequired,
  devicetype: PropTypes.string,
};

SendCommandPopup.defaultProps = {
  devicetype: '',
};

const mapDispatch = dispatch => {
  return {
    setDeviceCommandValue: (deviceId, command, value) => 
      dispatch(setDeviceCommandValue(deviceId, command, value)),
  };
};

export default injectIntl(
  compose(connect(null, mapDispatch), withStyles(s))
  (SendCommandPopup)
);



// WEBPACK FOOTER //
// ./src/components/Popup/SendCommandPopup.js